declare const __GIT_SHA__: string | undefined;
declare const __GIT_TAG__: string | undefined;

const gitSha = typeof __GIT_SHA__ !== "undefined" ? __GIT_SHA__ : "dev";
const gitTag = typeof __GIT_TAG__ !== "undefined" ? __GIT_TAG__ : "dev";
const shortSha = gitSha.substring(0, 7);
const githubUrl = `https://github.com/digis-payment/landing-page/commit/${gitSha}`;

// Display tag if it's a version tag, otherwise show short SHA
const versionDisplay = gitTag.startsWith("v") ? gitTag : shortSha;

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>&copy; 2026 DIGIS.IO - A SLACK-NATIVE COMPANY</div>
        <div style={{ display: "flex", gap: "24px" }}>
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <a href="#">Twitter</a>
          <a href="mailto:hello@digis.io">hello@digis.io</a>
          <a href={githubUrl} target="_blank" rel="noopener noreferrer">{versionDisplay}</a>
        </div>
      </div>
    </footer>
  );
}
